import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const Notification = (store) => ({
  path: ROUTE.NOTIFICATION,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'notification',
    loadReducer: () => import('./NotificationState'),
    loadComponent: () => import('./NotificationContainer'),
  })
})

export default Notification
